import React from 'react';
import Helmet from 'react-helmet';

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Página no encontrada</title>
      </Helmet>
      <div className='wrapper'>
        <div className='container page-not-found text-center'>
          <h1 className='title'>Page Not Found</h1>
        </div>
      </div>
    </>
  );
}
